import { faSignalStream as faSignalStreamLight } from '@fortawesome/pro-light-svg-icons';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { LiveStreamList } from '~/components/organisms/LiveStreamList';

export type IAppLiveStreamsPageProps = {
  appId: string;
};

export const AppLiveStreamsPage: React.FC<IAppLiveStreamsPageProps> = (
  props,
) => {
  const { appId } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('AppLiveStreamsPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId} />

      <Heading
        icon={<FontAwesomeIcon icon={faSignalStreamLight} />}
        title={t('AppLiveStreamsPage.title')}
        actions={
          <Button
            href={`/apps/${appId}/liveStreams/create`}
            icon={<FontAwesomeIcon icon={faPlus} />}
          >
            {t('AppLiveStreamsPage.create')}
          </Button>
        }
        subtitle={t('AppLiveStreamsPage.subtitle')}
      />

      <LiveStreamList appId={appId} />
    </>
  );
};
